export const SENTRY_VIEWER_SCRIPT_DSN = 'https://836cb86efda74074ac657cf762d45083@sentry.wixpress.com/105';
